import styled from '@emotion/styled';
import { AppUI } from '@seedlang/state';
import autobind from 'autobind-decorator';
import DeleteButton from 'components/button/delete_button';
import InPlaceCheckbox from 'components/form/in_place_checkbox';
import InPlaceText from 'components/form/in_place_text';
import { observer } from 'mobx-react';
import NavigationItemCreate from 'pages/builder/navigation_items/navigation_item_create';
import React from 'react';
import { Link } from 'react-router';
import { isBlank } from '@seedlang/utils';

const Wrapper = styled.div`
 
`;

@observer
class NavigationItemIndex extends React.Component {

  constructor(props) {
    super(props);
    this.getNavigationItems();
    if (!AppUI.membershipTypeStore.hasIndexData) {
      AppUI.membershipTypeStore.getIndex();
    }
  }

  @autobind getNavigationItems() {
    AppUI.navigationItemStore.getIndex();
  }

  onNavItemDelete(id) {
    AppUI.navigationItemStore.destroy({ ids: { navigationItemId: id }}, this.getNavigationItems);
  }

  @autobind membershipTypeNames(navigationItem) {
    if (!AppUI.membershipTypeStore.hasIndexData) { return ''; }
    if (isBlank(navigationItem.membershipTypeIds)) {
      return 'Any';
    }
    return navigationItem.membershipTypeIds.split(',').map(id => AppUI.membershipTypeStore.indexData.find(mt => mt.id === id)?.name).join(', ');
  }

  render() {
    return (
      <Wrapper>
        <NavigationItemCreate
          siteId={AppUI.site.id}
          afterCreate={this.getNavigationItems}
        />
        <table className='table-wrapper admin-table'>
          <thead>
          <tr>
          <th width='40' />
            <th>Position</th>
            <th>Name</th>
            <th>Path</th>
            <th>Signed Out</th>
            <th>Header</th>
            <th>Footer</th>
            <th>Settings</th>
            <th width='40' />
          </tr>
          </thead>
          <tbody>
          {
            AppUI.navigationItemStore.indexData.map(item => {
              return (
                <tr key={item.id}>
                  <td>
                    <Link to={{name: 'creator.navigation_items.edit', params: { navigationItemId: item.id }}}>
                      <i className='fa fa-chevron-right fa-block' />
                    </Link>
                  </td>
                  <td>
                    <InPlaceText
                      id={item.id}
                      defaultValue={item.position}
                      model='navigation_items'
                      field='position'
                      afterChange={this.getNavigationItems}
                    />
                  </td>
                  <td>
                    <InPlaceText
                      id={item.id}
                      defaultValue={item.name}
                      model='navigation_items'
                      field='name'
                    />
                  </td>
                  <td>
                    <InPlaceText
                      id={item.id}
                      defaultValue={item.path}
                      model='navigation_items'
                      field='path'
                      readOnly
                      hideEditable
                    />
                  </td>
                  <td>
                    <InPlaceCheckbox
                      id={item.id}
                      value={item.showWhenSignedOut}
                      model='navigation_items'
                      field='show_when_signed_out'
                    />
                  </td>
                  <td>
                    <InPlaceCheckbox
                      id={item.id}
                      value={item.showInHeader}
                      model='navigation_items'
                      field='show_in_header'
                    />
                  </td>
                  <td>
                    <InPlaceCheckbox
                      id={item.id}
                      value={item.showInFooter}
                      model='navigation_items'
                      field='show_in_footer'
                    />
                  </td>
                  <td>
                    <InPlaceCheckbox
                      id={item.id}
                      value={item.showInUserSettings}
                      model='navigation_items'
                      field='show_in_user_settings'
                    />
                  </td>
                  <td>
                    {
                      !item.routeName &&
                        <DeleteButton
                          onConfirm={() => this.onNavItemDelete(item.id)}
                          message='Delete this navigation item?'
                          className='fa-block right'
                        />
                    }
                  </td>
                </tr>
              );
            })
          }
          </tbody>
        </table>
      </Wrapper>
    );
  }
}

export default NavigationItemIndex;
